module.exports = __webpack_public_path__ + "fonts/ralewayextralightitalic.7e3c720.ttf";